<template>
  <div class="detail">
    <div class="detail-title">账单详情：</div>
    <el-table
      :loading="detailLoading"
      :data="detailData"
      :max-height="300"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" prop="serialNum" width="120">
      </el-table-column>
      <el-table-column
        label="状态"
        prop="processStatus"
        width="120"
        v-if="showStatus"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.processStatus | filterProcessStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="salesOrderNo"
        label="销售单号/售后单号"
        width="120"
      >
        <template slot-scope="scope">
          <!--是否查看原单 0否 1是-->
          <span
            v-if="scope.row.corpFlag === 1"
            style="color: #FF4D28; cursor: pointer"
            @click="handleBtn(scope.row)"
            >{{ scope.row.salesOrderNo }}</span
          >
          <span v-if="scope.row.corpFlag === 0">{{
            scope.row.salesOrderNo
          }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="orderTypeDesc" label="单据类型" />
      <el-table-column prop="skuCode" label="商品编码"> </el-table-column>
      <el-table-column prop="skuName" label="商品名称" width="120">
      </el-table-column>
      <el-table-column prop="purchaseQuantity" label="数量" width="120">
      </el-table-column>
      <el-table-column prop="purchasePrice" label="采购单价" width="120">
      </el-table-column>
      <el-table-column
        prop="purchaseAmount"
        label="采购金额/采退金额"
        width="120"
      >
      </el-table-column>
    </el-table>
    <!-- 对账管理-查看原单弹窗-->
    <el-dialog
      class="settle-modal"
      :visible.sync="orderDialogVisible"
      width="80%"
      :append-to-body="true"
    >
      <span slot="title" class="dialog-title">
        <span class="title">查看原单</span>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose('originOrderModal')"
          >确认</el-button
        >
      </span>
      <el-table
        :data="originalOrderList"
        border
        height="100"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="id" label="原单" width="180"> </el-table-column>
        <el-table-column prop="confirmDate" label="售后确认日期">
        </el-table-column>
        <el-table-column prop="saleOrder" label="售后单号"> </el-table-column>
        <el-table-column prop="skuCode" label="商品编码"> </el-table-column>
        <el-table-column prop="skuName" label="商品名称"> </el-table-column>
        <el-table-column prop="originalQuantity" label="原数量">
        </el-table-column>
        <el-table-column prop="unDeductQuantity" label="待抵扣数量">
        </el-table-column>
        <el-table-column prop="purchasePrice" label="采购单价">
        </el-table-column>
        <el-table-column prop="originalTotalAmount" label="原总价">
        </el-table-column>
        <el-table-column prop="unDeductTotalAmount" label="待抵扣总价">
        </el-table-column>
      </el-table>
      <el-table
        :data="deductionOrderList"
        border
        height="100"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="id" label="抵扣单" width="180">
        </el-table-column>
        <el-table-column prop="confirmTime" label="结算单确认日期">
        </el-table-column>
        <el-table-column prop="settleNo" label="结算单"> </el-table-column>
        <el-table-column prop="amount2"> </el-table-column>
        <el-table-column prop="amount2"> </el-table-column>
        <el-table-column prop="quantity" label="扣款数量"> </el-table-column>
        <el-table-column prop="purchasePrice" label="采购单价">
        </el-table-column>
        <el-table-column prop="purchaseTotalAmount" label="扣款总价">
        </el-table-column>
        <el-table-column prop="status" label="抵扣状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status | filterStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="settleDate" label="实际抵扣日期">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  doOriginalOrder,
  queryAccountDetail
} from "../../../../models/r4SettleModel";

export default {
  props: ["showStatus"],
  data() {
    return {
      detailLoading: false,
      detailData: [],
      orderDialogVisible: false,
      originalOrderList: [],
      deductionOrderList: []
    };
  },
  filters: {
    filterStatus(val) {
      let text = "";
      switch (val) {
        case 2:
          text = "已抵扣";
          break;
        case 1:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          text = "未抵扣";
          break;
        default:
          break;
      }
      return text;
    },
    filterProcessStatus(val) {
      // 已支付
      // 已挂起
      const type = {
        0: "处理中",
        1: "已处理"
      };
      return type[val];
    }
  },
  methods: {
    // 结算单明细
    loadAccountDetail(settleNo) {
      this.detailLoading = true;
      queryAccountDetail({ settleNo })
        .then(res => {
          this.detailLoading = false;
          console.log(res, "res");
          this.detailData = res.map((item, index) => {
            item.serialNum = index + 1;
            return item;
          });
        })
        .catch(err => {
          this.detailLoading = false;
          console.log(err);
          this.$message.error(err.message);
        });
    },
    // 查看原单
    goOriginalOrder(orderNumber) {
      doOriginalOrder({ orderNumber })
        .then(res => {
          this.originalOrderList = [
            {
              confirmDate: res.confirmDate,
              originalQuantity: res.originalQuantity,
              originalTotalAmount: res.originalTotalAmount,
              purchasePrice: res.purchasePrice,
              saleOrder: res.saleOrder,
              skuCode: res.skuCode,
              skuName: res.skuName,
              unDeductQuantity: res.unDeductQuantity,
              unDeductTotalAmount: res.unDeductTotalAmount
            }
          ];
          this.deductionOrderList = res.deductionOrder || [];
          this.orderDialogVisible = true;
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err.message);
        });
    },
    // 关闭弹窗
    handleClose(type) {
      switch (type) {
        case "originOrderModal":
          this.orderDialogVisible = false;
          break;
      }
    },
    handleBtn(record) {
      this.goOriginalOrder(record.salesOrderNo);
    }
  }
};
</script>
<style lang="scss" scoped>
.detail-title {
  font-size: 12px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #333333;
  margin-bottom: 6px;
}
.blue {
  color: #236bdc;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/billConfirm/components/detailTable.vue